<template>
    <div>
        <van-nav-bar
                title="Información de identidad"
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <div id="applyidcard">
            <div class="apply_idcardwrap">
                <div class="apply_banner">
                    <!--<img src="../../assets/img/applyhead.png" />-->
                </div>
                <div class="apply_head">
                    <div class="apply_hview">
                        <img src="../../assets/img/applyhead04.webp" />
                    </div>
                </div>

                <div class="apply_idcardtitle">Subir la INE/IFE mexicana</div>

                <div class="apply_topview">
                    <div class="apply_top">
                        Cuando tomes la foto, asegúrate de que INE/IFE <br/>
                        tenga un borde completo, una letra clara y un brillo <br/>
                        bien equilibrado.
                    </div>
                </div>
                <div class="apply_idcard_formview">
                    <div class="apply_idcard_formcont">
                        <div class="apply_idcardupview">
                            <template v-if="uploadimg">
                                <img :src="uploadimg" />
                            </template>
                            <template v-else>
                                <img src="../../assets/img/idcardUP.png" />
                            </template>
                            <div class="apply_idcardupcont" @click.stop="gotoStartUp"></div>
                        </div>
                        <div class="apply_idcardbackview">
                            <template v-if="idcardBackimg">
                                <img :src="idcardBackimg" />
                            </template>
                            <template v-else>
                                <img src="../../assets/img/idcardUP.png" />
                            </template>
                            <div class="apply_idcardupcont" @click.stop="gotoStartBack"></div>
                        </div>
                    </div>

                    <div class="apply_topview_new">
                        <div class="apply_top_new">
                            <p>
                                Asegúrese de que la siguiente información sea coherente con INE/IFE
                                <span>(no se puede cambiar después del envío del CURP).</span>
                            </p>
                        </div>
                    </div>

                    <div class="apply_formview">
                        <div class="bank_conttop">

                            <div class="bank_ctitems" @click="onCheckitem('1')">
                                <div class="bank_ctitem" :class="isCheck == '1' ? 'bank_ctitem_active' : ''">
                                    <van-field
                                            v-model="middle_name"
                                            label=""
                                            type="text"
                                            placeholder="Apellido materno"
                                            :clearable="isTrue"
                                    />
                                </div>
                            </div>

                            <div class="bank_ctitems" @click="onCheckitem('2')">
                                <div class="bank_ctitem" :class="isCheck == '2' ? 'bank_ctitem_active' : ''">
                                    <van-field
                                            v-model="last_name"
                                            label=""
                                            type="text"
                                            placeholder="Apellido paterno"
                                            :clearable="isTrue"
                                    />
                                </div>
                            </div>

                            <div class="bank_ctitems" @click="onCheckitem('3')">
                                <div class="bank_ctitem" :class="isCheck == '3' ? 'bank_ctitem_active' : ''">
                                    <van-field
                                            v-model="first_name"
                                            label=""
                                            type="text"
                                            placeholder="Nombre"
                                            :clearable="isTrue"
                                    />
                                </div>
                            </div>

                            <div class="bank_ctitems" @click="onCheckitem('4')">
                                <div class="bank_ctitem" :class="isCheck == '4' ? 'bank_ctitem_active' : ''">
                                    <van-field
                                            v-model="identity"
                                            label=""
                                            type="text"
                                            placeholder="CURP (Sólo ingrese números y letras)"
                                            :clearable="isTrue"
                                            maxlength="18"
                                            @blur="onIdentity"
                                    />
                                </div>
                            </div>

                            <div class="idcard_items">
                                <div class="idcard_ileft">
                                    <div class="bank_ctitems">
                                        <div class="bank_ctitem bank_ctitem_active" style="background: #F0F0F0;">
                                            <van-field
                                                    style="background: #F0F0F0;"
                                                    v-model="RFCnormal"
                                                    label=""
                                                    type="text"
                                                    placeholder="RFC"
                                                    disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="idcard_iright">
                                    <div class="bank_ctitems" @click="onCheckitem('5')">
                                        <div class="bank_ctitem bank_ctitem_rfc" :class="isCheck == '5' ? 'bank_ctitem_active' : ''">
                                            <van-field
                                                    v-model="RFCval"
                                                    label=""
                                                    type="text"
                                                    maxlength="3"
                                                    placeholder="3 dígitos"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div class="bank_contmiddle">
                        <div class="bank_contmleft">
                            <div class="bank_contmlview">
                                <img src="../../assets/img/apply_useicon.png" />
                            </div>
                        </div>
                        <div class="bank_contmright">
                            <p>
                                Superapoyomax mantiene su información personal privada y segura durante todo el proceso.
                            </p>
                        </div>
                    </div>

                    <div class="bank_contdown">
                        <van-button round color="#19A95C" block style="height: 1.111111rem;" @click.stop="onConfirm">
                            <span style="font-weight: 500;">Enviar</span>
                        </van-button>
                    </div>

                </div>
            </div>

            <input type="file" accept="image/*" capture="user" ref="videoFile" @change="changeVideo" class="file-input" hidden />

            <input type="file" accept="image/*" capture="user" ref="videoFileBack" @change="changeVideoBack" class="file-input" hidden />
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { verifyIdentity } from '@/api/apply'
    import { identityDetect6 } from '@/api/upload'
    import { getLoanInfo } from '@/api/loan';

    import Crypto from '@/utils/crypto'

    import { Toast } from 'vant';

    import ImageCompressor from 'js-image-compressor'

    import $ from 'jquery';

    export default{
        data() {
            return {
                isTrue: true,
                isCheck: '1',
                uploadimg: null,
                idcardBackimg: null,
                first_name: null,
                middle_name: null,
                last_name: null,
                identity: null,
                RFCnormal: null,
                RFCnormalval: null,
                RFCval: null,
            }
        },
        mounted() {

        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            onIdentity(){
                let identity = this.identity;
                if(identity && identity.length){
                    let useRFCnormal = identity.slice(0, 10);

                    this.RFCnormalval = useRFCnormal;
                    this.RFCnormal = 'RFC:' + useRFCnormal;
                } else {
                    this.RFCnormalval = null;
                    this.RFCnormal = null;
                }
            },
            onCheckitem(type){
                this.isCheck = type;
            },
            gotoStartUp() {
                //this.uploadimg = null;
                this.verfiysucc = true;
                this.$refs.videoFile.value = null;
                this.$refs.videoFile.dispatchEvent(new MouseEvent('click'));
            },
            changeVideo() {
                console.log('身份证正面')
                let that = this;
                const files = that.$refs.videoFile.files;

                if (files && files.length > 0) {
                    let file = files[0];

                    console.log(file)

                    if (file.type.indexOf("image/") == -1) {
                        Toast("Formato de foto incorrecto"); //照片格式错误
                        return;
                    }

                    // TODO:压缩视频
                    if (file.size > 10 * 1024 * 1024) {
                        Toast('Tamaño de foto excedido por favor tome otra foto'); //照片大小超限，超出 10 MB,请重新录制
                        return;
                    }
                    /*Toast.loading({
                        message: 'Subir en proceso...',
                        duration: 0,
                        forbidClick: true
                    });*/
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        let result = reader.result;
                        //that.faceReco(result, file.size)
                        //that.faceReco(file, file.size, result)
                        that.compressionImage(file, result)
                    }
                }
            },
            compressionImage (file, base64img) {
                let _this = this;
                return new Promise((resolve, reject) => {
                    // eslint-disable-next-line no-new
                    new ImageCompressor({
                        file: file,
                        quality: 0.8,
                        maxWidth: 1500,
                        maxHeight: 1500,
                        redressOrientation: false,

                        // 压缩前回调
                        beforeCompress: function (result) {
                            console.log(result)
                            console.log('压缩之前图片尺寸大小: ', result.size)
                            console.log('mime 类型: ', result.type)
                        },

                        success: function (result) {
                            console.log(result)
                            console.log('压缩之后图片尺寸大小: ', result.size)
                            console.log('mime 类型: ', result.type)
                            console.log('实际压缩率： ', ((file.size - result.size) / file.size * 100).toFixed(2) + '%')

                            _this.faceReco(result, result.size, base64img)
                            resolve(result)
                        },
                        error (e) {
                            reject(e)
                        }
                    })
                })
            },
            dataURItoBlob(dataURI) {
                // base64格式转化为blob对象
                let byteString = atob(dataURI.split(",")[1]);

                let mimeString = dataURI
                    .split(",")[0]
                    .split(":")[1]
                    .split(";")[0];

                let ab = new ArrayBuffer(byteString.length);
                let ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                return new Blob([ab], { type: mimeString });
            },
            faceReco(result, fileSize, base64img){
                let _this = this;
                /*Toast.loading({
                    message: 'Bajo verificación...', //验证中
                    duration: 0,
                    forbidClick: true
                });*/

                //let useaccessToken = this.$store.state.common.accessToken;
                let postData = {
                    fs1: result,
                    fs1_size: fileSize,
                };

                // let forms = new FormData()
                //
                // forms.append('fs1', result)
                // forms.append('fs1_size', fileSize)

                //console.log(forms)

                this.getCommomParams('front', result, fileSize, base64img)


                // verifyLive(forms, useaccessToken, 'Rapidayuda').then(res => {
                //     //验证成功
                //     Toast.clear();
                //     console.log(res)

                //     if(res.code == 0){
                //         _this.verfiysucc = true;
                //         _this.uploadimg = base64img;

                //         _this.$router.replace({
                //             path: '/compoundloan/confirmloan'
                //         })
                //     } else {
                //         _this.verfiysucc = false;
                //         _this.uploadimg = base64img;
                //     }
                // }, error => {
                //     console.log(error)
                //     Toast.clear();
                //     _this.verfiysucc = false;
                //     _this.uploadimg = base64img;
                // });

                console.log(result)

                //模拟调用风控sdk
                setTimeout(() => {
                    //验证成功
                    //Toast.clear();

                    _this.verfiysucc = true;

                    //_this.uploadimg = result;

                    _this.uploadimg = base64img;

                }, 200)
            },

            gotoStartBack() {
                //this.idcardBackimg = null;
                this.verfiysucc = true;
                this.$refs.videoFileBack.value = null;
                this.$refs.videoFileBack.dispatchEvent(new MouseEvent('click'));
            },
            changeVideoBack() {
                console.log('身份证反面')
                let that = this;
                const files = that.$refs.videoFileBack.files;

                if (files && files.length > 0) {
                    let file = files[0];

                    console.log(file)

                    if (file.type.indexOf("image/") == -1) {
                        Toast("Formato de foto incorrecto"); //照片格式错误
                        return;
                    }

                    // TODO:压缩视频
                    if (file.size > 10 * 1024 * 1024) {
                        Toast('Tamaño de foto excedido por favor tome otra foto'); //照片大小超限，超出 10 MB,请重新录制
                        return;
                    }
                    /*Toast.loading({
                        message: '上传中...',
                        duration: 0,
                        forbidClick: true
                    });*/
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        let result = reader.result;
                        //that.faceReco(result, file.size)
                        //that.faceRecoBack(file, file.size, result)
                        that.compressionImageBack(file, result)
                    }
                }
            },
            compressionImageBack (file, base64img) {
                let _this = this;
                return new Promise((resolve, reject) => {
                    // eslint-disable-next-line no-new
                    new ImageCompressor({
                        file: file,
                        quality: 0.8,
                        maxWidth: 1500,
                        maxHeight: 1500,
                        redressOrientation: false,

                        // 压缩前回调
                        beforeCompress: function (result) {
                            console.log(result)
                            console.log('压缩之前图片尺寸大小: ', result.size)
                            console.log('mime 类型: ', result.type)
                        },

                        success: function (result) {
                            console.log(result)
                            console.log('压缩之后图片尺寸大小: ', result.size)
                            console.log('mime 类型: ', result.type)
                            console.log('实际压缩率： ', ((file.size - result.size) / file.size * 100).toFixed(2) + '%')

                            _this.faceRecoBack(result, result.size, base64img)
                            resolve(result)
                        },
                        error (e) {
                            reject(e)
                        }
                    })
                })
            },
            faceRecoBack(result, fileSize, base64img){

                console.log(299999)
                let _this = this;
                /*Toast.loading({
                    message: 'Bajo verificación...', //验证中
                    duration: 0,
                    forbidClick: true
                });*/

                //let useaccessToken = this.$store.state.common.accessToken;
                let postData = {
                    fs1: result,
                    fs1_size: fileSize,
                };

                // let forms = new FormData()
                //
                // forms.append('fs1', result)
                // forms.append('fs1_size', fileSize)
                //
                // console.log(forms)

                this.getCommomParams('reverse', result, fileSize, base64img)

                //模拟调用风控sdk
                setTimeout(() => {
                    //验证成功
                    //Toast.clear();

                    _this.verfiysucc = true;

                    //_this.uploadimg = result;

                    _this.idcardBackimg = base64img;

                }, 200)
            },
            async getCommomParams(type, result, fileSize, base64img) {
                let _this = this;
                let timezoneName = getTimezoneName(); //时区
                loadingShow();
                let ip = await getUserIp();

                if(type == 'front'){
                    let commonParams = _this.frontCommonParams(timezoneName, ip, result, fileSize, base64img)
                } else if(type == 'reverse'){
                    let commonParams = _this.reverseCommonParams(timezoneName, ip, result, fileSize, base64img)
                } else if(type == 'identity'){
                    let commonParams = _this.identityCommonParams(timezoneName, ip)
                }
            },
            frontCommonParams(time_zone, ip, result, fileSize, base64img) {
                let access_token = getAccessToken();
                let forms = new FormData();
                forms.append('zzm_yya_hqb', access_token);
                forms.append('aaa_off_csl', '111');
                forms.append('omr_uvo_uam', '1');
                forms.append('fs1', result);
                forms.append('ppg_dog_zej', fileSize);

                let currentTime = new Date().getTime();
                let secretClient = 'oewioewgoijpghrporeghpwueoreloikweiokeweekqqierijfd';
                let cipherStr = Crypto.encrypt(currentTime + "#" + secretClient, secretClient);

                console.log('客户端密钥:' + secretClient);
                console.log('客户端时间戳:' + currentTime);
                console.log('客户端密文:' + cipherStr);

                forms.append('ckn_emo_hfg', currentTime);

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                identityDetect6(forms, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    'egewg-key': 'rigewjgewgewhiofee',
                    'x-timestamp': currentTime,
                    'x-ciphertext': cipherStr,
                    ...headerParams
                }).then(res => {
                    console.log(res)
                    loadingHide()
                    Toast.clear()
                    if (res.ci == 200) {
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                        if(useData){
                            let { dwx_bpd_hjq, frv_mvh_uel, nmg_zmz_fws, pew_sdk_oqh } = JSON.parse(useData);

                            this.first_name = dwx_bpd_hjq;
                            this.middle_name = frv_mvh_uel;
                            this.last_name = nmg_zmz_fws;
                            this.identity = pew_sdk_oqh;

                            let identity = pew_sdk_oqh;

                            if(identity && identity.length > 0){
                                let useRFCnormal = identity.slice(0, 10);

                                this.RFCnormalval = useRFCnormal;
                                this.RFCnormal = 'RFC:' + useRFCnormal;
                            }
                        }
                    } else {
                        Toast(res.ms);
                    }
                }, error => {
                    loadingHide()
                    Toast.clear()
                })
            },
            reverseCommonParams(time_zone, ip, result, fileSize, base64img) {
                let access_token = getAccessToken();
                let forms = new FormData();
                forms.append('zzm_yya_hqb', access_token);
                forms.append('aaa_off_csl', '111');
                forms.append('omr_uvo_uam', '1');
                forms.append('fs2', result);
                forms.append('njz_ukx_uhc', fileSize);

                let currentTime = new Date().getTime();
                let secretClient = 'oewioewgoijpghrporeghpwueoreloikweiokeweekqqierijfd';
                let cipherStr = Crypto.encrypt(currentTime + "#" + secretClient, secretClient);

                console.log('客户端密钥:' + secretClient);
                console.log('客户端时间戳:' + currentTime);
                console.log('客户端密文:' + cipherStr);

                forms.append('ckn_emo_hfg', currentTime);

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                identityDetect6(forms, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    'egewg-key': 'rigewjgewgewhiofee',
                    'x-timestamp': currentTime,
                    'x-ciphertext': cipherStr,
                    ...headerParams
                }).then(res => {
                    console.log(res)
                    loadingHide()
                    Toast.clear()
                    if (res.ci == 200) {
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                    }
                }, error => {
                    loadingHide()
                    Toast.clear()
                })
            },
            identityCommonParams(time_zone, ip){
                let access_token = getAccessToken();
                let _this = this;

                let first_name = this.first_name;
                let middle_name = this.middle_name;
                let last_name = this.last_name;
                let identity = this.identity;
                let RFCnormalval = this.RFCnormalval;
                let RFCval = this.RFCval;

                let useRFC = RFCnormalval + RFCval;

                let postData = {
                    zzm_yya_hqb: access_token,
                    aaa_off_csl: '111',
                    pc_zheng_ty: '1',
                    pc_fan_ty: '2',
                    ti_tarjeta_de: '1',
                    de_nombre_pa: first_name, //first_name
                    mi_nombre_dd: middle_name, //middle_name
                    la_nombre_st: last_name, //last_name
                    ak_identidad_ck: identity, //identity
                    co_rfc_de: useRFC //rfc_code
                };

                console.log(postData)

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                verifyIdentity(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    console.log(res)
                    if (res.ci == 200) {
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                        if (useData) {
                            let useDataJSON = JSON.parse(useData);
                            let { bqr_rle_jto } = useDataJSON;
                            if(bqr_rle_jto == 8001){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applywork'
                                })
                            } else if(bqr_rle_jto == 8002){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applycontacts'
                                })
                            } else if(bqr_rle_jto == 8004){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applyperson'
                                })
                            } else if(bqr_rle_jto == 8005){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applyidcard'
                                })
                            } else if(bqr_rle_jto == 8006){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/livingverify'
                                })
                            } else if(bqr_rle_jto == 7106){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/livingverify'
                                })
                            } else if(bqr_rle_jto == 8010){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applybank'
                                })
                            } else if(bqr_rle_jto == 7101){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 7102){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 7105){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 8110){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            }
                        }
                    } else {
                        Toast(res.ms);
                    }
                }, error => {
                    loadingHide()
                })
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let {vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, server_time current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                this.orderStatusNor = omi_fje_qly;
                                this.getStatus(omi_fje_qly, huw_kdq_nxo,  ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isInfoLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })

                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,13等待第三方黑名单验证,18等待自动外呼,19等待人脸对比,20人工审核质检中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            /*if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {

                            }*/

                            if(current_is_reloan != undefined){
                                if(current_is_reloan == 1){
                                    _this.isReloan = 1;
                                } else {
                                    _this.isReloan = null;
                                }
                            } else {
                                _this.isReloan = null;
                            }

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }
                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;

                            _this.$router.replace({
                                path: '/loanpage/loanstatus'
                            });
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/repayment'
                        });
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.replace({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }
                        } else {
                            _this.isReloan = 0;
                        }

                        _this.$router.replace({
                            path: '/loanpage/firstloan'
                        });
                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
            onConfirm() {
                let uploadimg = this.uploadimg; //正面
                let idcardBackimg = this.idcardBackimg; //反面

                if(uploadimg && uploadimg.length){
                    if(idcardBackimg && idcardBackimg.length){

                        let first_name = this.first_name;
                        let middle_name = this.middle_name;
                        let last_name = this.last_name;
                        let identity = this.identity;
                        let RFCnormalval = this.RFCnormalval;
                        let RFCval = this.RFCval;

                        if(first_name && first_name.length){
                            if(middle_name && middle_name.length){
                                if(last_name && last_name.length){
                                    if(identity && identity.length){
                                        if(identity.length == 18){
                                            this.getCommomParams('identity')
                                        } else {
                                            Toast('El número de identificación debe tener 18 dígitos') //身份证号须为18位
                                        }
                                    } else {
                                        Toast('Ingresa número de identificación') //请输入身份证号
                                    }
                                } else {
                                    Toast('Ingresa tu apellido paterno') //请输入父姓
                                }
                            } else {
                                Toast('Ingresa tu apellido materno') //请输入母姓
                            }
                        } else {
                            Toast('Ingresa tu nombre') //请输入名字
                        }

                    } else {
                        Toast('Sube foto reverso del INE') //请上传身份证反面照片
                    }
                } else {
                    Toast('Sube foto anverso del INE') //请上传身份证正面照片
                }
            },
        }
    }
</script>

<style less scoped>
    .apply_banner{
        width: 100%;
        height: 1.45rem;
        box-sizing: border-box;
        padding: 0.25rem 0.277778rem 0 0.277778rem;
        position: relative;
    }
    .apply_idcardwrap .apply_head{
        width: 100%;
        height: 0.7rem;
        position: relative;
    }
    .apply_hview{
        width: 8.944444rem;
        height: 0.555556rem;
        position: absolute;
        left: 0.56rem;
        top: -0.611111rem;
    }
    .apply_hview img{
        display: block;
        width: 8.944444rem;
        height: 0.555556rem;
    }
    .apply_idcardtitle{
        width: 100%;
        height: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 600;
        color: #333333;
        line-height: 0.555556rem;
        box-sizing: border-box;
        padding-left: 0.555556rem;
    }
    .apply_topview{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.555556rem;
    }
    .apply_idcardwrap .apply_top{
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 0.5rem;
        padding: 0.194444rem 0 0.305556rem 0;
    }

    .apply_idcard_formview{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.555556rem 1.2rem 0.555556rem;
    }

    .bank_contmiddle{
        width: 100%;
        height: 1.611111rem;
        display: flex;
        justify-content: flex-start;
    }
    .bank_contmleft{
        width: 0.666667rem;
        height: 0.444444rem;
    }
    .bank_contmlview{
        width: 0.394444rem;
        height: 0.444444rem;
        margin-top: 2px;
    }
    .bank_contmlview img{
        display: block;
        width: 0.394444rem;
        height: 0.444444rem;
    }
    .bank_contmright{
        width: 7.888889rem;
        height: 1.0rem;
        display: flex;
        align-items: center;
    }
    .bank_contmright p{
        font-size: 0.333333rem;
        font-weight: 500;
        color: #999999;
    }
    .bank_contdown{
        width: 7.722222rem;
        height: 1.111111rem;
        margin: 0 auto;
    }

    .apply_idcard_formcont{
        width: 100%;
        height: 9.861111rem;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.19);
        border-radius: 0.222222rem;
        margin-bottom: 0.555556rem;
        box-sizing: border-box;
        padding: 0.694444rem 1.027778rem;
    }
    .apply_idcardupview{
        width: 100%;
        height: 3.916667rem;
        position: relative;
        overflow: hidden;
    }
    .apply_idcardupview img{
        display: block;
        width: 100%;
    }
    .apply_idcardbackview{
        width: 100%;
        height: 3.916667rem;
        margin-top: 0.666667rem;
        position: relative;
        overflow: hidden;
    }
    .apply_idcardbackview img{
        display: block;
        width: 100%;
    }
    .apply_idcardupcont{
        width: 100%;
        height: 3.916667rem;
        position: absolute;
        left: 0;
        top: 0;
    }
    .apply_topview_new{
        width: 100%;
        height: 2.083333rem;
    }
    .apply_top_new{
        width: 100%;
        height: 2.083333rem;
        box-sizing: border-box;
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DDF2E7;
        border-radius: 0.111111rem;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 0.5rem;
    }
    .apply_top_new p{
        text-align: center;
    }
    .apply_top_new span{
        color: #00B264;
    }
    .apply_formview{
        width: 100%;
        height: auto;
        padding-top: 0.333333rem;
    }
    .bank_conttop{
        width: 100%;
        height: auto;
    }
    .bank_ctitems{
        width: 100%;
        height: 1.472222rem;
    }
    .bank_ctitem{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.083333rem;
        border: 1px solid #DEE0E6;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bank_ctitem_active{
        border: 1px solid #00CA88;
    }
    .bank_ctileft{
        width: auto;
        height: 14px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctiright{
        width: auto;
        height: 8px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-right: 0.416667rem;
    }
    .bank_ctirview{
        width: 13px;
        height: 8px;
    }
    .bank_ctirview img{
        display: block;
        width: 13px;
        height: 8px;
    }
    .bank_ctitem_active .bank_ctileft{
        color: #1A1A1A;
    }
    .bank_ctitem .bank_code{
        display: block;
        width: 90%;
        height: 0.8rem;
        outline: none;
        border: none;
        background: #ffffff;
        border-radius: 0.333333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctitem_active .bank_code{
        color: #1A1A1A;
    }
    .idcard_items{
        width: 100%;
        height: 1.472222rem;
        display: flex;
        justify-content: space-between;
    }
    .idcard_ileft{
        width: 6.5rem;
        height: 1.472222rem;
    }
    .idcard_iright{
        width: 2.166667rem;
        height: 1.472222rem;
    }
    .bank_ctitem_rfc .van-cell{
        padding: 4px 0.111111rem 4px 0.22222rem;
    }
</style>

<style less>
    #applyidcard .van-action-sheet__description{
        background: #19A95C;
        color: #ffffff;
        font-size: 16px;
    }
    #applyidcard .van-action-sheet__cancel{
        color: #FB4840;
    }
    #applyidcard .van-action-sheet__item .van-action-sheet__name{
        color: #19A95C;
    }
    #applyidcard .van-cell{
        padding: 4px 0.444444rem 4px 0.416667rem;
    }
    #applyidcard .van-dialog{
        width: 76.39vw;
        border-radius: 0.277778rem;
    }
    #applyidcard .van-dialog__confirm, .van-dialog__confirm:active{
        background: #19A95C;
    }
</style>